import { Typography } from 'antd';
import { IComponentProperty, ComponentPropertyType } from '../ComponentProperty';
import { v4 as uuidv4 } from 'uuid';

export const PSUTextProps : Array<IComponentProperty>  = [
    { "name": "id", "type": ComponentPropertyType.String , "required": true, "description": "The ID for this typography", displayName: "Id" },
    { "name": "value", "type": ComponentPropertyType.String , "required": true, "description": "The text to display", displayName: "Text" },
    { "name": "code", "type": ComponentPropertyType.Boolean , "required": false, "description": "Display this text as code.", displayName: "Code" },
    { "name": "copyable", "type": ComponentPropertyType.Boolean , "required": false, "description": "Whether this text is copyable", displayName: "Copyable" },
    { "name": "textType", "type": ComponentPropertyType.Select , "required": false, "description": "The type of text to display.", displayName: "Type", options: [
        { value: null, text: "Default" },
        { value: "secondary", text: "Secondary" },
        { value: "success", text: "Success" },
        { value: "warning", text: "Warning" },
        { value: "danger", text: "Danger" }	
    ] },
]

export const NewPSUText = () => {
    return {
        "$type": 'PowerShellUniversal.Components.Text, PowerShellUniversal',
        "value": "Text",
        "type": "Text",
        "id": uuidv4(),
    }
}

export default function PSUText(props) {
    return <Typography.Text code={props.code} type={props.textType}>{props.value}</Typography.Text>
}